import { postApiRequest } from 'api/index';
import { IActionDetailsRequest, IActionDetailsResponse } from 'types/groupActions';

export const postActionDetails = (params: IActionDetailsRequest): Promise<IActionDetailsResponse> => {
    return postApiRequest(`/actions/progress/detail/`, params);
};
